let base_url=null;

if ((!(process.env.CORDOVA_PLATFORM == undefined) || !( process.env.IS_ELECTRON == undefined)) && process.env.NODE_ENV == 'production') {
    base_url = process.env.VUE_APP_API_BASE_URL
}
else {
    base_url = "/enterprise"
}
export default base_url;